import { AxiosPromise } from 'axios';
import { logout } from 'src/actions/authentication/login/Login.actions';
import { store } from 'src/store';
import { TypedResource } from 'src/services/api-client/resource/base/TypedResource';
import OfflineInvestor from 'src/entities/OfflineInvestor';

export default class OfflineInvestorResource extends TypedResource<OfflineInvestor> {
  constructor() {
    super('/projects/:projectId/offline-investors', OfflineInvestor);
  }

  public delete(projectId: string, offlineInvestorId: string): AxiosPromise {
    this.getHeaders();

    const url: string = '/projects/' + projectId + '/offline-investors/' + offlineInvestorId;

    return this.httpClient
      .delete(url)
      .catch((errorResponse) => {
        if (errorResponse.response.data.message.includes('Unauthenticated')) {
          store.dispatch(logout());
        }
        throw errorResponse;
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/api-client/resource/OfflineInvestorResource.tsx